import { 
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";

// Testimonial data
const testimonials = [
  {
    id: 1,
    name: "Alex Johnson",
    role: "Product Manager",
    company: "TechVenture",
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'%3E%3Ccircle cx='30' cy='30' r='30' fill='%233da6a6'/%3E%3Ccircle cx='30' cy='20' r='10' fill='%23f5f5f5'/%3E%3Cpath d='M45,45 C45,37 38,30 30,30 C22,30 15,37 15,45' fill='%23f5f5f5'/%3E%3C/svg%3E",
    text: "Working with this developer was amazing! The pixel art aesthetics in our app received so much positive feedback from users. Their attention to detail is unmatched.",
    rating: 5
  },
  {
    id: 2,
    name: "Emma Rodriguez",
    role: "Art Director",
    company: "GameCraft Studios",
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'%3E%3Ccircle cx='30' cy='30' r='30' fill='%23cf56a1'/%3E%3Ccircle cx='30' cy='20' r='10' fill='%23f5f5f5'/%3E%3Cpath d='M45,45 C45,37 38,30 30,30 C22,30 15,37 15,45' fill='%23f5f5f5'/%3E%3C/svg%3E",
    text: "As an art director, I'm very particular about design implementation. This developer translated our pixel art concepts perfectly into functional code. Highly recommend!",
    rating: 5
  },
  {
    id: 3,
    name: "Michael Chen",
    role: "Startup Founder",
    company: "PixelPlay",
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'%3E%3Ccircle cx='30' cy='30' r='30' fill='%232d5d3b'/%3E%3Ccircle cx='30' cy='20' r='10' fill='%23f5f5f5'/%3E%3Cpath d='M45,45 C45,37 38,30 30,30 C22,30 15,37 15,45' fill='%23f5f5f5'/%3E%3C/svg%3E",
    text: "Brought our retro-style game to life with clean code and creative solutions. The pixel art animations were particularly impressive. Would definitely work together again!",
    rating: 4
  },
  {
    id: 4,
    name: "Sarah Williams",
    role: "UX Designer",
    company: "CreativePixels",
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'%3E%3Ccircle cx='30' cy='30' r='30' fill='%23f4cf4c'/%3E%3Ccircle cx='30' cy='20' r='10' fill='%23f5f5f5'/%3E%3Cpath d='M45,45 C45,37 38,30 30,30 C22,30 15,37 15,45' fill='%23f5f5f5'/%3E%3C/svg%3E",
    text: "The perfect blend of technical skill and artistic understanding. They took our UX wireframes and turned them into a beautiful, functional interface with pixel-perfect details.",
    rating: 5
  },
  {
    id: 5,
    name: "James Lee",
    role: "Indie Game Developer",
    company: "Retro Pixels",
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'%3E%3Ccircle cx='30' cy='30' r='30' fill='%23e05c5c'/%3E%3Ccircle cx='30' cy='20' r='10' fill='%23f5f5f5'/%3E%3Cpath d='M45,45 C45,37 38,30 30,30 C22,30 15,37 15,45' fill='%23f5f5f5'/%3E%3C/svg%3E",
    text: "I've collaborated with many developers, but few understand pixel art like this one. They helped optimize our game's performance while maintaining the authentic retro aesthetic.",
    rating: 5
  },
  {
    id: 6,
    name: "Olivia Garcia",
    role: "Marketing Director",
    company: "Retro Revolution",
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'%3E%3Ccircle cx='30' cy='30' r='30' fill='%235ecc5e'/%3E%3Ccircle cx='30' cy='20' r='10' fill='%23f5f5f5'/%3E%3Cpath d='M45,45 C45,37 38,30 30,30 C22,30 15,37 15,45' fill='%23f5f5f5'/%3E%3C/svg%3E",
    text: "Helped us create a marketing site with beautiful pixel art elements that perfectly represented our brand's retro vibe. Responsive, professional, and extremely talented.",
    rating: 4
  }
];

const Reviews = () => {
  const renderStars = (rating: number) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <span key={i}>
          {i < rating ? (
            // Filled star
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#f4cf4c" stroke="none">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
            </svg>
          ) : (
            // Empty star
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f4cf4c" strokeWidth="2">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
            </svg>
          )}
        </span>
      );
    }
    return stars;
  };

  // Desktop grid view
  const renderDesktopGrid = () => (
    <div className="hidden md:grid grid-cols-2 lg:grid-cols-3 gap-6">
      {testimonials.map((testimonial) => (
        <div 
          key={testimonial.id}
          className="bg-white/10 backdrop-blur-md border-2 border-grass/30 p-6 shadow-[6px_6px_0px_0px_rgba(30,58,43,0.3)] transform transition-all duration-300 hover:-translate-y-2"
        >
          <div className="flex items-start gap-3 mb-4">
            <img 
              src={testimonial.image} 
              alt={testimonial.name} 
              className="w-12 h-12"
            />
            <div>
              <h4 className="font-degular text-grass-light text-lg">{testimonial.name}</h4>
              <p className="font-mono text-xs text-white/70">{testimonial.role}, {testimonial.company}</p>
            </div>
          </div>
          
          <p className="font-mono text-sm text-white/90 mb-4 min-h-[100px]">{testimonial.text}</p>
          
          <div className="flex">
            {renderStars(testimonial.rating)}
          </div>
        </div>
      ))}
    </div>
  );

  // Mobile carousel view
  const renderMobileCarousel = () => (
    <div className="md:hidden w-full">
      <Carousel className="w-full">
        <CarouselContent>
          {testimonials.map((testimonial) => (
            <CarouselItem key={testimonial.id}>
              <Card className="bg-white/10 backdrop-blur-md border-2 border-grass/30 mb-8 border-none">
                <CardContent className="p-6">
                  <div className="flex items-start gap-3 mb-4">
                    <img 
                      src={testimonial.image} 
                      alt={testimonial.name} 
                      className="w-12 h-12"
                    />
                    <div>
                      <h4 className="font-degular text-grass-light text-lg">{testimonial.name}</h4>
                      <p className="font-mono text-xs text-white/70">{testimonial.role}, {testimonial.company}</p>
                    </div>
                  </div>
                  
                  <p className="font-mono text-sm text-white/90 mb-4">{testimonial.text}</p>
                  
                  <div className="flex">
                    {renderStars(testimonial.rating)}
                  </div>
                </CardContent>
              </Card>
            </CarouselItem>
          ))}
        </CarouselContent>
        <div className="flex justify-center gap-4 mt-4">
          <CarouselPrevious className="relative static left-0 right-auto translate-y-0 bg-forest text-white hover:bg-forest-light" />
          <CarouselNext className="relative static right-0 left-auto translate-y-0 bg-forest text-white hover:bg-forest-light" />
        </div>
      </Carousel>
    </div>
  );

  return (
    <section id="reviews" className="py-20 relative overflow-hidden">
      <div className="section-container">
        <h2 className="section-title text-white">Client Reviews</h2>
        
        <div className="mb-12 max-w-2xl mx-auto text-center">
          <p className="font-mono text-white/80">
            Here's what clients and collaborators have to say about working with me on pixel art projects and software development.
          </p>
        </div>
        
        {renderDesktopGrid()}
        {renderMobileCarousel()}
      </div>
    </section>
  );
};

export default Reviews;